import type { FC, ReactNode } from 'react';
import { Social, LinkedinLogo, FacebookLogo, TwitterLogo, InstagramLogo } from './SocialLinks.styles';

interface SocialLink {
  socialLinks: {
    title: string;
    url: string;
  }[];
}

const SocialLink: FC<SocialLink> = ({ socialLinks }) => {
  const logoMap: { [key: string]: ReactNode } = {
    facebook: <FacebookLogo />,
    twitter: <TwitterLogo />,
    linkedin: <LinkedinLogo />,
    instagram: <InstagramLogo />,
  };

  return (
    <Social data-testid="social-links">
      {socialLinks?.map((link, index) => (
        <a key={index} href={link?.url} target="_blank" rel="noopener noreferrer" aria-label={link?.title} data-testid="social-link">
          {logoMap[link?.title]}
        </a>
      ))}
    </Social>
  );
};

export default SocialLink;
